import React, {Component} from "react";
import config from 'react-global-configuration';
import {Route, Switch, withRouter} from "react-router-dom";
import AdminNavbar from "components/Navbars/AdminNavbar";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";
import MobSidebar from "components/Sidebar/LeftSidebar";
import {style} from "variables/Variables.jsx";
import image from "assets/img/sidebar-3.jpg";
import ViewDashboard from "views/ViewDashboard";
import Logout from "views/Logout";
import NotificationSystem from "react-notification-system";
import UserList from "views/UserList.jsx";
import UserProfile from "views/UserProfile.jsx";
import ViewQuery from "views/ViewQuery.jsx";
import WelcomePage from "views/WelcomePage.jsx";
import EditQuery from "views/EditQuery.jsx";
import Transaction from "views/Transaction";
import InvoiceDashboard from "views/InvoiceDashboard";
import Invoice from "views/Invoice.jsx";
import InvoiceProcess from "components/Invoice/InvoiceProcess.jsx"
import EmiScheme from "reports/EmiScheme.jsx";
import DailySalesReport from "components/SalesReport/DailySalesReport.jsx";
import DailySalesReportEmi from "components/SalesReport/DailySalesReportEmi.jsx";
import PhonePeSalesReport from "components/SalesReport/PhonePeSalesReport.jsx";
import GooglePaySalesReport from "components/SalesReport/GooglePaySalesReport.jsx";
import EmiSalesReport from "components/SalesReport/EmiSalesReport.jsx";
import DccSalesReport from "components/SalesReport/DccSalesReport.jsx";
import DccWeeklySalesReport from "components/SalesReport/DccWeeklySalesReport.jsx";
import DccMonthlySalesReport from "components/SalesReport/DccMonthlySalesReport.jsx";
import DccWeeklySalesReports from "components/SalesReport/DccWeeklySalesReports.jsx";
import DccMonthlySalesReports from "components/SalesReport/DccMonthlySalesReports.jsx";
import GooglePayMonthlySalesReports from "components/SalesReport/GooglePayMonthlySalesReports.jsx";
import GooglePayWeeklySalesReport from "components/SalesReport/GooglePayWeeklySalesReport.jsx";
import EMIWeeklySalesReport from "components/SalesReport/EMIWeeklySalesReport.jsx";
import EMIMonthlySalesReport from "components/SalesReport/EMIMonthlySalesReport.jsx";
import AdditionalData from "views/AdditionalData.jsx";
import GpaySettlementReport from "components/SettlementReport/GpaySettlementReport.jsx";
import RupaySettlementReport from "components/SettlementReport/RupaySettlementReport.jsx";
import PhonePeSettlementReport from "components/SettlementReport/PhonePeSettlementReport.jsx";
import EodSettlementReport from "components/SettlementReport/EodSettlementReport.jsx";
import DailySettlementReport from "components/SettlementReport/DailySettlementReport.jsx";
import DccSettlementReport from "components/SettlementReport/DccSettlementReport.jsx";
import LiveTransactionReport from "components/TransactionReport/LiveTransactionReport";
import DccTransactionReport from "components/TransactionReport/DccTransactionReport";
import EmiTransactionReport from "components/TransactionReport/EmiTransactionReport";
import ChoiceEmiTransactionReport from "components/TransactionReport/ChoiceEmiTransactionReport";
import AcquirerSummaryReport from "components/TransactionReport/AcquirerSummaryReport";
import IssuerSummaryReport from "components/TransactionReport/IssuerSummaryReport";
import TxnSummaryReport from "components/TransactionReport/TxnSummaryReport";
import EmiTransactionReportDebitCard from "components/TransactionReport/EmiTransactionReportDebitCard";
import GooglePayTransactionReport from "components/TransactionReport/GooglePayTransactionReport";
import ContactLessTransactionReport from "components/TransactionReport/ContactLessTransactionReport";
import CashBackTransactionReport from "components/TransactionReport/CashBackTransactionReport";
import EodTransactionReport from "components/TransactionReport/EodTransactionReport";
import PhonePeTransactionReport from "components/TransactionReport/PhonePeTransactionReport";
import UpiPayTransactionReport from "components/TransactionReport/UpiPayTransactionReport";
import GenieTransactionReport from "components/TransactionReport/GenieTransactionReport";
import AxisAggregatorReport from "components/TransactionReport/AxisAggregatorReport";
import FlexiPayTransactionReport from "components/TransactionReport/FlexiPayTransactionReport";
import EchargeSlipReport from "components/SupportModule/EchargeSlipReport.jsx";
import ZoneWiseEmiReport from "components/SettlementReport/ZoneWiseEmiReport";
import AggregatedSettlementReport from "components/SettlementReport/AggregatedSettlementReport";
import AcqFallbackReport from "components/SupportModule/AcqFallbackReport.jsx";
import SpeedAndReliabilityReport from "components/SupportModule/SpeedAndReliabilityReport.jsx";
import ConnectivityReport from "components/SupportModule/ConnectivityReport.jsx";
import AcquirerSpeedReport from "components/SupportModule/AcquirerSpeedReport.jsx";
import IssuerSpeedReport from "components/SupportModule/IssuerSpeedReport.jsx";
import EdcHealthReport from "components/SupportModule/EdcHealthReport.jsx"
import LoginReport from "components/SupportModule/LoginReport.jsx";
import BounceBackIndicatorReport from "components/SupportModule/BounceBackIndicatorReport.jsx";
import PoserReport from "components/SupportModule/PoserReport.jsx";
import PoserDetails from "components/SupportModule/PoserDetails.jsx";
import OkrReport from "components/SupportModule/OkrReport.jsx";
import InnovitiBusinessSnapshot from "components/SupportModule/InnovitiBusinessSnapshot.jsx";
import UtidSummaryReport from "components/SupportModule/UtidSummaryReport.jsx"
import BankTidReport from "components/SupportModule/BankTidReport.jsx";
import BankTidReportGeo from "components/SupportModule/BankTidReportGeo.jsx";
import RelianceBankUtidReport from "components/TransactionReport/RelianceBankUtidReport.jsx";
import CardDetailsReport from "components/SupportModule/CardDetailsReport.jsx";
import IdleTidReports from "components/SupportModule/IdleTidReports.jsx";
import IdownloadReport from "components/SupportModule/IdownloadReport.jsx";
import GenieMarginMtdReport from "components/SupportModule/GenieMarginMtdReport";
import BinManagerReport from "components/SupportModule/BinManagerReport";
import MasterDataV2 from "views/MasterDataV2";
import BrandViewer from "brandemi/BrandViewer.jsx";
import MerchantViewer from "brandemi/MerchantViewer.jsx";
import LinkedView from "brandemi/LinkedView.jsx";
import IndexData from "brandemi/IndexData.jsx";
import APIConfiguration from "brandemi/APIConfiguration.jsx";
import BrandProductMaster from "brandemi/BrandProductMaster.jsx";
import MerchantProductMaster from "brandemi/MerchantProductMaster.jsx";
import MasterData from "brandemi/MasterData.jsx";
import UnmappedView from "brandemi/UnmappedView.jsx";
import MappedView from "brandemi/MappedView.jsx";
import EditPromotion from "brandemi/EditPromotion.jsx";
import RunPromotions from "brandemi/RunPromotions.jsx";
import CreatePromotion from "brandemi/CreatePromotion.jsx";
import PromotionMaster from "brandemi/PromotionMaster.jsx";
import BrandViewPromotion from "brandemi/BrandViewPromotion.jsx";
import MerchantUpload from "brandemi/MerchantUpload.jsx";
import AdminViewPromotion from "brandemi/AdminViewPromotion.jsx";
import Campaign from "brandemi/Campaign.jsx";
import MasterData2 from "brandemi/MasterData2.jsx";
import CreateSchemes from "brandemi/CreateSchemes.jsx";
import CreateSchemesMultiple from "brandemi/CreateSchemesMultiple.jsx";
import SchemesList from "brandemi/SchemesList.jsx";
import MerchantPromotionMaster from "brandemi/MerchantPromotionMaster.jsx";
import MerchantViewPromotion from "brandemi/MerchantViewPromotion.jsx";
import AdminUploadProducts from "brandemi/AdminUploadProducts.jsx";
import DataExporter from "brandemi/DataExporter.jsx";
import NewUnmappedView from "brandemi/NewUnmappedView.jsx";
import BrandMerchantProductMapper from "brandemi/BrandMerchantProductMapper.jsx";
import MerchantBrandProductMapper from "brandemi/MerchantBrandProductMapper.jsx";
import AdminCreateSchemes from "brandemi/AdminCreateSchemes.jsx";
import AdminSchemesList from "brandemi/AdminSchemesList.jsx";
import AdminPromotionMaster from "brandemi/AdminPromotionMaster.jsx";
import AdminPromotionMasterBackend from "brandemi/AdminPromotionMasterBackend.jsx";
import AdminEditPromotion from "brandemi/AdminEditPromotion.jsx";
import AdminCreatePromotion from "brandemi/AdminCreatePromotion.jsx";
import NewDashboard  from "brandemi/NewDashboard.jsx";
import NewMerchantMaster from "brandemi/NewMerchantMaster.jsx";
import NewCreatePromotion from "brandemi/NewCreatePromotion.jsx";
import NewEditPromotion from "brandemi/NewEditPromotion.jsx";
import NewViewPromotion from "brandemi/NewViewPromotion.jsx";
import AdminNewCreateSchemes from "brandemi/AdminNewCreateSchemes.jsx";
import AdminNewCreateSchemesView from "brandemi/AdminNewCreateSchemesView.jsx";
import AdminNewCreateSchemesViewBankEMI from "brandemi/AdminNewCreateSchemesViewBankEMI.jsx";
import NewSchemesMaster from "brandemi/NewSchemesMaster.jsx";
import AdminNewSchemesList from "brandemi/AdminNewSchemesList.jsx";
import NewDataExporter from "brandemi/NewDataExporter.jsx";

//pnc
import NewDataExporter2 from "brandemi/NewDataExporter2.jsx";


import AutomationButton from "brandemi/AutomationButton.jsx";
import AutomationButtonOld from "brandemi/AutomationButtonOld.jsx";
import AutomationButtonLatest from "brandemi/AutomationButtonLatest.jsx";
// import LatestMerchantMaster from "brandemi/LatestMerchantMaster.jsx";
import  SapphireFoodDownloadReport  from "../components/Dashboard/SappireFoodList";
// import LatestMerchantMaster1 from "brandemi/LatestMerchantMaster1.jsx";
import NewBrandViewer from "brandemi/NewBrandViewer.jsx";
import NewBrandViewerNew from "brandemi/NewBrandViewerNew.jsx";
import AdminNewCreateSchemesEdit from "brandemi/AdminNewCreateSchemesEdit.jsx";

import AdminCreatePromotion1 from "brandemi/AdminCreatePromotion1.jsx";
import AdminViewPromotion1 from "brandemi/AdminViewPromotion1.jsx";
import AdminEditPromotion1 from "brandemi/AdminEditPromotion1.jsx";
import AdminNewCreateSchemesBankEMI from "brandemi/AdminNewCreateSchemesBankEMI.jsx";


import EmailUsers from "brandemi/EmailUsers.jsx";
import BrandEMISchemeEnablement from "brandemi/BrandEMISchemeEnablement.jsx";
// import BrandEmailConfig from "brandemi/BrandEmailConfig.jsx";
// import BrandEMISalesReportNew from "brandemi/BrandEMISalesReportNew.jsx";
import ManageCommunication from "brandemi/ManageCommunication.jsx";
import BrandEMITransactionReport from "brandemi/BrandEMITransactionReport.jsx";
import BrandEMITransactionReportNew from "brandemi/BrandEMITransactionReportNew.jsx";
import APILogReport from "brandemi/APILogReport.jsx";
import MerchantBrandIntegration from "brandemi/MerchantBrandIntegration.jsx";
import BrandEMIMIS from "brandemi/BrandEMIMIS.jsx";
import PromotionMapping from "brandemi/PromotionMapping.jsx";
// import AdminNewSchemesList2 from "brandemi/AdminNewSchemesList2.jsx";



//import Brand EMI pages

import MobWelcomeMenu from "views/MobWelcomeMenu.jsx";
import MobWelcomePage from "views/MobWelcomePage.jsx";
import TotalEmiTransDetails from "ipos/ChildComponents/TransactionDetails"
import AcqurierDashboard from "components/Dashboard/AcqurierDashboard.jsx";
import MerchantDashboard from "components/Dashboard/MerchantDashboard.jsx";
import DashboardDetails from "components/Dashboard/DashboardDetails.jsx";
import AdminInvoice from "views/AdminInvoice.jsx";
import TotalEMINavbar from "../ipos/js/BottomNav";
//import BrandEMINavbar from "../Brand/js/BrandNavbar";
import UnipayNextNavbar from "../components/BottomBars/UnipayBar";
import "../components/BottomBars/UnipayBar.css";
import allRoutes from "routes.js";
import {connect}  from  "react-redux";
import jwt_decode from "jwt-decode";
import Notifications from "views/Notifications";
import Page404 from "views/Page404.jsx"
import axios from "axios";
import Cookies from 'universal-cookie';
import {isMobile} from "react-device-detect";
import IdleTimer from 'react-idle-timer'
import BarCode from "views/BarCode.jsx";
import FlatFilesTest from "components/FlatFiles/FlatFilesTest.jsx";
import StellrReport from "components/SupportModule/StellrReport.jsx";
import TableauReports from "views/TableauReports.jsx";
import GenieWalletBalance from "components/SupportModule/GenieWalletBalance.jsx";
import TableauWorkbook from "tableau/TableauWorkbook.jsx";
import TableauWorksheet from "tableau/TableauWorksheet.jsx";
import TableauReport from "tableau/TableauReport.jsx";
import TableauReportTest from "tableau/TableauReportTest.jsx"
import UnsupportedTerminalsReports from "components/SupportModule/UnsupportedTerminalsReports.jsx";
import BinManagerSummaryReport from "components/TransactionReport/BinManagerSummaryReport.jsx";
import ProductErrorReport from "components/SupportModule/ProductErrorReport.jsx";
import ProductErrorReportTest from "components/SupportModule/ProductErrorReportTest.jsx";
import UserAccessPermission from "views/UserAccessPermission.jsx";
import DownloadQueue from "views/DownloadQueue.jsx";
import RelianceUtidSummaryReport from "components/TransactionReport/RelianceUtidSummaryReport.jsx";
import RelianceUtidWiseBillingSummaryReport from "components/TransactionReport/RelianceUtidWiseBillingSummaryReport.jsx";
import MonthWiseSummary from "components/Invoice/MonthWiseSummary.jsx";
import ActiveUtid from "components/Invoice/ActiveUtid.jsx";
import AdaniGasStationDailyReport from "components/AdaniReports/AdaniGasStationDailyReport.jsx";
import UpiVpaHandlerReport from "components/TransactionReport/UpiVpaHandlerReport.jsx";
import LiveTransactionDumpReport from "components/SupportModule/LiveTransactionDumpReport.jsx";
import RelianceGrabUpiPayTransactionReport from "components/TransactionReport/RelianceGrabUpiPayTransactionReport.jsx";
// import EodTransactionReport1 from "components/TransactionReport/EodTransactionReport1";
// import EodTransactionReport2 from "components/TransactionReport/EodTransactionReport2";
import BtidGapReport from "components/TransactionReport/BtidGapReport";
import EnigmaticSmileReport from "components/TransactionReport/EnigmaticSmileReport";
import ErupeeTransactionReport from "components/TransactionReport/ErupeeTransactionReport";
import TableauEmbed1 from "tableau/TableauEmbed1.jsx";
import TableauEmbed2 from "tableau/TableauEmbed2.jsx"
import LoungeView1 from "tableau/LoungeView1.jsx";
import DmsView from "tableau/DmsView";
import LoungePartnerReport from "tableau/LoungePartnerReport.jsx";
import DonationReport from "tableau/DonationReport.jsx";
import LoungeReportAPI from "tableau/LoungeReportAPI.jsx";
import LoungeReportAPIQA from "tableau/LoungeReportAPIQA.jsx";
import DonationReportForTest from "tableau/DonationReportForTest.jsx";
import HeatMap from "views/HeatMap.js";
import BvpDashboard from "views/BvpDashboard";
// import MainComponent from "views/MainComponent";
import GenieAcquisitionReport from "components/SupportModule/GenieAcquisitionReport.jsx";
import AdminClonePromotion from "../brandemi/AdminClonePromotion";
import UBCTransactionReport from "components/TransactionReport/UBCTransactionReport.jsx";
import AddCampaign from "components/CampaignModule/AddCampaign.jsx";
import EditCampaign from "components/CampaignModule/EditCampaign.jsx";
import ViewCampaign from "components/CampaignModule/ViewCampaign.jsx";
import HDFCUPITransactionReport from "components/TransactionReport/HDFCUPITransactionReport.jsx";
import GRDDumpReport from "components/SupportModule/GRDDumpReport.jsx";
import GenieRoi from "components/GenieRoiModule/GenieRoi.jsx";
import LinkPKYCDocument from "components/SupportModule/LinkPKYCDocument.jsx";
import BeatPlanReport from "components/SupportModule/BeatPlanReport.jsx";
import BeatPlanDetailReport from "components/SupportModule/BeatPlanDetailReport.jsx"
import LinkPKYCReport from "components/SupportModule/LinkPKYCReport.jsx";
import ChargebackReport from "components/SupportModule/ChargebackReport.jsx";
import RefundReport from "components/SupportModule/RefundReport.jsx";
import BussinessVolumeReport from "components/SupportModule/BussinessVolumeReport.jsx";
import ComplaintReport from "components/SupportModule/ComplaintReport.jsx";
import AddComplaint from "components/SupportModule/AddComplaint.jsx";
import LinkMerchantMovementHistory from "components/SupportModule/LinkMerchantMovementHistory.jsx";
import EditComplaint from "components/SupportModule/EditComplaint.jsx";
import CrispFinanceReport from "components/SupportModule/CrispFinanceReport.jsx";
import FailedUPITransactionToEFTReport from "components/TransactionReport/FailedUPITransactionToEFTReport.jsx";

config.set({
    API_URL: process.env.REACT_APP_NODE_API_URL,
    //API_URL: "http://127.0.0.1:4000/api/node",
    REPORT_CSV_DAYS_LIMIT: 15,
    LOG_URL: process.env.REACT_APP_KIBANA_LOG_URL,
});

let dashboardRoutes = [];
let sidebarRoutes=[];
let MenuList = [];
let MenuCount = 0;
let stateUpdateCounter = 0;
class Admin extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        const token = localStorage.usertoken;
        const tokenPermission = localStorage.userPermission;
        let loggedIn = true;
        if (token == null) {
            loggedIn = false;
        }
        this.state = {
            _notificationSystem: null,
            image: image,
            color: "black",
            hasImage: true,
            fixedClasses: "dropdown show-dropdown open",
            loggedIn,
            isTimedOut: false,
            menulist:[],
            totalemi:false,
            brandemi:false,
            unipay:false,
            showsidebar:false,
            opacity:1
        };


    }
    _onAction(e) {
        // console.log('user did something', this.idleTimer.getRemainingTime())
    }

    _onActive(e) {
        // console.log('user is active', e)
        // console.log('time remaining', this.idleTimer.getRemainingTime())
        var remain_time = this.idleTimer.getRemainingTime();
        if(remain_time==0) {
            this.update_idle_token();
        }
    }

    _onIdle(e) {
        // console.log('user is idle', e)
        // console.log('last active', this.idleTimer.getLastActiveTime())
        // console.log("delete token")
        this.update_idle_token();
    }
    update_idle_token(){
        const valid_token = localStorage.usertoken;
        const decoded_valid_token = jwt_decode(valid_token);
        axios.post(config.get('API_URL')+'/users/update-token', {
                user_id: decoded_valid_token._id,
                user_token: localStorage.usertoken,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            })
            .then(response => {
                console.log("Timeout");
            })
            .catch(err => {
                console.log(err)
            })
    }

    allRoutes(){
        const token = localStorage.usertoken;
        const tokenPermission = localStorage.userPermission;
// console.log(token);
        let utype='';
        let accessPermissions = [];

        let is_user_access = false;
        if(token != null) {
            const decoded = jwt_decode(token);
            utype = decoded.userType;
            is_user_access = decoded.user_admin_access;
        }
        if(tokenPermission != null) {
            const decoded_per = jwt_decode(tokenPermission);
            accessPermissions = decoded_per.accessPermissions;
        }

        var subPer = [];
        var MainMenu = [];
        var is_menu_exist = false;
        MenuList.length = 0;
        //console.log("Access Menu"+JSON.stringify(accessPermissions))
        accessPermissions.map((permissionName, i) => {
            if (permissionName.access_type == 'Submenu') {
                subPer.push(permissionName.access_name);
            }
            if (permissionName.access_type == 'Menu') {
                MainMenu.push(permissionName.access_name);

                MenuCount = 0;
                if (permissionName.access_name == "totalemi") {
                    MenuList.push("totalemi");
                    MenuCount++;
                }
                if (permissionName.access_name == "brandemi") {
                    MenuList.push("brandemi");
                    MenuCount++;
                }
                if (permissionName.access_name == "headrun_reports") {
                    MenuList.push("unipaynext");
                    MenuCount++;
                }
            }
        });

        // storage code for Mob menu
        localStorage.removeItem("MenuList");
        MenuList = MenuList.filter((value,index) => MenuList.indexOf(value) ===  index);

        if(MenuList.length==1)
        {
            if (MenuList[0] == "totalemi") {
                this.props.currentMenu("totalemi");
            }
            else if (MenuList[0] == "brandemi") {
                this.props.currentMenu("brandemi");
            }
            else if (MenuList[0] == "headrun_reports") {
                this.props.currentMenu("unipaynext");
            }
        }
        let menusArray=JSON.stringify(MenuList)
        // this.props.currentList(MenuList);
        localStorage.setItem("MenuList",menusArray);


        //console.log(subPer);
        var count = 0;
        allRoutes.map((menuName, index) => {
            //accessPermissions.map((permissionName, i) => {
            if (MainMenu.includes(menuName.menu_per) === true) {
                dashboardRoutes.push({
                    path: menuName.path,
                    name: menuName.name,
                    icon: menuName.icon,
                    component: menuName.component,
                    layout: menuName.layout,
                    isDrop: menuName.isDrop,
                    submenus: [],
                });
                try {
                    menuName.submenus.map((sub, index1) => {
                        if (subPer.includes(sub.menu_per) === true) {
                            //console.log(sub.menu_per); console.log(subPer); console.log(subPer.includes(sub.menu_per));
                            try {
                                dashboardRoutes[count].submenus.push({
                                    path: sub.path,
                                    name: sub.name,
                                    icon: sub.icon,
                                    component: sub.component,
                                    layout: sub.layout,
                                    dis_order: sub.dis_order,
                                });
                                if (sub.name == "User Administration") {
                                    is_menu_exist = true;
                                }
                            } catch (e) {
                                console.log(e);
                            }
                        }
                    });
                } catch (e) {
                    console.log(e);
                }

                try {
                    dashboardRoutes[index].submenus.sort((a, b) => a.dis_order - b.dis_order);
                } catch (e) {
                    //console.log(e);
                }
                count++;
            }
        });
        // console.log("dashboardRoutes"+JSON.stringify(dashboardRoutes));

        dashboardRoutes.map((val,pos) =>{
            if(val.name === "UnipayNext")
            { sidebarRoutes=val.submenus}
        })

        //console.log("dashboardRoutes"+JSON.stringify(sidebarRoutes));
        if(is_menu_exist===false && is_user_access===true) {
            dashboardRoutes.push({
                path: "/users",
                name: "User Administration",
                menu_per: "user_administration",
                icon: "pe-7s-users",
                component: UserList,
                layout: "/admin",
                dis_order: 10
            })
        }
        try {
            if(dashboardRoutes.length<2 && dashboardRoutes[0].submenus.length>0){
                var parentMenu = [];

                dashboardRoutes[0].submenus.map((submenu, index1) => {
                    parentMenu.push({
                        path: submenu.path,
                        name: submenu.name,
                        icon: submenu.icon,
                        component: submenu.component,
                        layout: submenu.layout,
                        submenus: []
                    })
                })

                dashboardRoutes = parentMenu;
            }
        } catch (e) {
            console.log(e);
        }
    }


    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    getRoutes = routes => {
        return routes.map((prop, key) => {
            if (prop.isDrop===true) {
                return this.getRoutes(prop.submenus);
            }
            if (prop.layout === "/admin") {
                return (
                    <Route
                        path={prop.layout + prop.path}
                        render={props => (
                            <prop.component
                                {...props}
                                handleClick={this.handleNotificationClick}
                            />
                        )}
                        key={key}
                    />
                );
            } else {
                return null;
            }

        });
    };

    handleImageClick = image => {
        this.setState({ image: image });
    };
    handleColorClick = color => {
        this.setState({ color: color });
    };
    handleHasImage = hasImage => {
        this.setState({ hasImage: hasImage });
    };
    handleFixedClick = () => {
        if (this.state.fixedClasses === "dropdown") {
            this.setState({ fixedClasses: "dropdown show-dropdown open" });
        } else {
            this.setState({ fixedClasses: "dropdown" });
        }
    };
    componentWillMount() {

        dashboardRoutes = [];
        this.allRoutes();
    }
    componentDidMount() {
        this.isTokenExpired(localStorage.usertoken);
        const cookies = new Cookies();
        try {
            const usr_token = localStorage.usertoken;
            const usr_decoded = jwt_decode(usr_token);
            //console.log(usr_decoded);
            if(cookies.get('myCache')===undefined) {
                const emailAllay = [];
                emailAllay.push(usr_decoded.email);
                cookies.set('userDetails', emailAllay, {path: '/'});
                cookies.set('myCache', 'Y', {path: '/'});
            }
            else {
                var udetails = cookies.get('userDetails');
                if(udetails.includes(usr_decoded.email)===false) {
                    udetails.push(usr_decoded.email);
                }
                cookies.set('userDetails', udetails, {path: '/'});
            }
        }catch (err) {
            console.log("expired check failed!");
        }

        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        var color = Math.floor(Math.random() * 4 + 1);
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        // _notificationSystem.addNotification({
        //   title: <span data-notify="icon" className="pe-7s-gift" />,
        //   message: (
        //     <div>
        //       Welcome to <b>Light Bootstrap Dashboard</b> - a beautiful freebie for
        //       every web developer.
        //     </div>
        //   ),
        //   level: level,
        //   position: "tr",
        //   autoDismiss: 15
        // });
    }
    componentDidUpdate(e) {
        this.isTokenExpired(localStorage.usertoken);
        this.isValidToken();
        if (
            window.innerWidth < 993 &&
            e.history.location.pathname !== e.location.pathname &&
            document.documentElement.className.indexOf("nav-open") !== -1
        ) {
            document.documentElement.classList.toggle("nav-open");
        }


        if (e.history.action === "PUSH") {
            document.body.scrollTop = 0;
            document.body.scrollTop = 0;
            this.refs.mainPanel.scrollTop = 0;
        }
    }
    isValidToken(){

        const valid_token = localStorage.usertoken;
        const decoded_valid_token = jwt_decode(valid_token);
        axios.post(config.get('API_URL')+'/users/verify-token', {
                user_id: decoded_valid_token._id,
                user_token: localStorage.usertoken,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            })
            .then(response => {
                try {
                    if (response.data.status=='error') {
                        this.handleNotificationClick("tc", 3, "Session Has been expired.");
                        setTimeout( function(){
                            localStorage.removeItem("usertoken");
                            localStorage.removeItem("userPermission");
                            this.setState({
                                loggedIn: false
                            });
                            window.location.href = "/";
                        }.bind(this)  , 1000 );
                        // Try Now
                    }

                    if(response.data.password_exp=='first_login'){
                        if(decoded_valid_token.authType!='Google') {
                            if (this.props.location.pathname != '/admin/user-profile') {
                                this.handleNotificationClick("tc", 3, "Your Password Has been expired. Please Change your Password");
                                setTimeout(function () {
                                    window.location.href = "/admin/user-profile";
                                }.bind(this), 2000);
                            }
                        }
                    }
                } catch (err) {
                    console.log("expired check failed!");
                }

            })
            .catch(err => {
                console.log(err)
            })
    }
    isTokenExpired = token => {
        try {
            const decoded = jwt_decode(token);
            if (decoded.exp < Date.now() / 1000) {
                localStorage.removeItem("usertoken");
                localStorage.removeItem("userPermission");
                this.setState({
                    loggedIn: false
                });
                window.location.href = "/";
            }
        } catch (err) {
            console.log("expired check failed!");
        }
    };

    UnipayCallback = (dataFromChild) => {
        if(dataFromChild.includes("more"))
        { this.setState({showsidebar:!this.state.showsidebar,opacity:(this.state.showsidebar?1:0.2)});}
        else
        {this.setState({showsidebar:false,opacity:1});}
    }

    render() {
        if(this.state.loggedIn === false){
            //return <Redirect to ="/admin/login"/>
            window.location.href = "/";
        }
        return (
            <>
                <div className="wrapper">
                    <IdleTimer
                        ref={ref => { this.idleTimer = ref }}
                        element={document}
                        onActive={this.onActive}
                        onIdle={this.onIdle}
                        onAction={this.onAction}
                        debounce={250}
                        timeout={1000 * 60 * 60} />
                    <NotificationSystem ref="notificationSystem" style={style} />
                    {!isMobile &&  <Sidebar {...this.props} routes={dashboardRoutes} image={this.state.image}
                                            color={this.state.color}
                                            hasImage={this.state.hasImage} />}
                    <div className="fixed-content-unipay">
                        { isMobile && this.state.showsidebar && <MobSidebar  {...this.props} routes={sidebarRoutes} UnipayParentCallback={this.UnipayCallback}/> }
                        <div id="main-panel" className="main-panel" ref="mainPanel" style={{opacity:this.state.opacity}}>

                            {!isMobile && <AdminNavbar
                                {...this.props}

                            />}
                            <Switch>{this.getRoutes(dashboardRoutes)}
                                <Route path="/admin/view-query/:id" component={ViewQuery} />
                                <Route path="/admin/edit-query/:id" component={EditQuery} />
                                <Route path="/admin/amcharts" component={ViewDashboard} />
                                <Route path="/admin/logout" component={Logout} />
                                <Route path="/admin/user-profile" component={UserProfile} />
                                <Route path="/admin/notifications/:id" component={Notifications} />
                                <Route path="/admin/notifications" component={Notifications} />
                                <Route path="/admin/emi-scheme" component={EmiScheme} />
                                <Route path="/admin/daily-sales-report-emi" component={DailySalesReportEmi} />
                                <Route path="/admin/daily-sales-report" component={DailySalesReport} />
                                <Route path="/admin/dcc-sales-report" component={DccSalesReport} />
                                <Route path="/admin/weekly-sales-report" component={DccWeeklySalesReport} />
                                <Route path="/admin/monthly-sales-report" component={DccMonthlySalesReport} />
                                <Route path="/admin/dcc-weekly-sales-report" component={DccWeeklySalesReports} />
                                <Route path="/admin/google-pay-weekly-sales-report" component={GooglePayWeeklySalesReport} />
                                <Route path="/admin/dcc-monthly-sales-report" component={DccMonthlySalesReports} />
                                <Route path="/admin/google-pay-monthly-sales-report" component={GooglePayMonthlySalesReports} />
                                <Route path="/admin/emi-weekly-sales-report" component={EMIWeeklySalesReport} />
                                <Route path="/admin/emi-monthly-sales-report" component={EMIMonthlySalesReport} />
                                <Route path="/admin/echargeslip-report" component={EchargeSlipReport} />
                                <Route path="/admin/PhonePe-sales-report" component={PhonePeSalesReport} />
                                <Route path="/admin/google-pay-sales-report" component={GooglePaySalesReport} />
                                <Route path="/admin/EMI-sales-report" component={EmiSalesReport} />
                                <Route path="/admin/daily-settlement-report" component={DailySettlementReport} />
                                <Route path="/admin/eod-settlement-report" component={EodSettlementReport} />
                                <Route path="/admin/dcc-settlement-report" component={DccSettlementReport} />
                                <Route path="/admin/google-pay-settlement-report" component={GpaySettlementReport} />
                                <Route path="/admin/rupay-settlement-report" component={RupaySettlementReport} />
                                <Route path="/admin/PhonePe-settlement-report" component={PhonePeSettlementReport} />
                                <Route path="/admin/live-transaction-report" component={LiveTransactionReport} />
                                <Route path="/admin/dcc-transaction-report" component={DccTransactionReport} />
                                <Route path="/admin/emi-transaction-report" component={EmiTransactionReport} />
                                <Route path="/admin/emi-transaction-report-debit-card" component={EmiTransactionReportDebitCard} />
                                <Route path="/admin/choice-emi-transaction-report" component={ChoiceEmiTransactionReport} />
                                <Route path="/admin/acquirer-summary-report" component={AcquirerSummaryReport} />
                                <Route path="/admin/issuer-summary-report" component={IssuerSummaryReport} />
                                <Route path="/admin/txn-summary" component={TxnSummaryReport} />
                                <Route path="/admin/google-pay-transaction-report" component={GooglePayTransactionReport} />
                                <Route path="/admin/PhonePe-transaction-report" component={PhonePeTransactionReport} />
                                <Route path="/admin/upi-transaction-report" component={UpiPayTransactionReport} />
                                <Route path="/admin/genie-transaction-report" component={GenieTransactionReport} />
                                <Route path="/admin/axis-aggregator-report" component={AxisAggregatorReport} />
                                <Route path="/admin/zone-wise-emi-report" component={ZoneWiseEmiReport} />
                                <Route path="/admin/aggregated-settlement-report" component={AggregatedSettlementReport} />
                                <Route path="/admin/acquirer-fallback-report" component={AcqFallbackReport} />
                                <Route path="/admin/speed-and-reliability-report" component={SpeedAndReliabilityReport} />
                                <Route path="/admin/connectivity-report" component={ConnectivityReport} />
                                <Route path="/admin/acquirer-speed-report" component={AcquirerSpeedReport} />
                                <Route path="/admin/issuer-speed-report" component={IssuerSpeedReport} />
                                <Route path="/admin/edc-health-report" component={EdcHealthReport} />
                                <Route path="/admin/login-report" component={LoginReport} />
                                <Route path="/admin/bounce-back-indicator-report" component={BounceBackIndicatorReport} />
                                <Route path="/admin/poser-report" component={PoserReport} />
                                <Route path="/admin/poser-details" component={PoserDetails} />
                                <Route path="/admin/okr-report" component={OkrReport} />
                                <Route path="/admin/innoviti-business-snapshot-report" component={InnovitiBusinessSnapshot} />
                                <Route path="/admin/utid-summary-report" component={UtidSummaryReport} />
                                <Route path="/admin/bank-tid-report" component={BankTidReport} />
                                <Route path="/admin/bank-tid-report-geo" component={BankTidReportGeo} />
                                <Route path="/admin/reliance-bank-utid-report" component={RelianceBankUtidReport} />
                                <Route path="/admin/idle-tid-report" component={IdleTidReports} />
                                <Route path="/admin/card-details-report" component={CardDetailsReport} />
                                <Route path="/admin/contact-less-transaction-report" component={ContactLessTransactionReport} />
                                <Route path="/admin/transaction-cash-back-report" component={CashBackTransactionReport} />
                                <Route path="/admin/daily-transaction-report" component={EodTransactionReport} />
                                <Route path="/admin/home-page" component={WelcomePage} />
                                <Route path="/admin/welcomepage" component={MobWelcomePage} />
                                <Route path="/admin/welcomemenu" component={MobWelcomeMenu} />
                                <Route path="/admin/unmapped-view/:id" component={UnmappedView} />
                                <Route path="/admin/mapped-view/:id" component={MappedView} />
                                <Route path="/admin/brand-viewer/:id" component={BrandViewer} />
                                <Route path="/admin/merchant-viewer/:id" component={MerchantViewer} />
                                <Route path="/admin/master-data" component={MasterData} />
                                <Route path="/admin/brand-product-master" component={BrandProductMaster} />
                                <Route path="/admin/merchant-product-master" component={MerchantProductMaster} />
                                {/*<Route path="/admin/subvention-merchant" component={SubventionMerchant} />
            <Route path="/admin/subvention-brand" component={SubventionBrand} />*/}
                <Route path="/admin/linked-view/:id" component={LinkedView} />
                <Route path="/admin/index-data" component={IndexData} />
                <Route path="/admin/api-configuration" component={APIConfiguration} />
                <Route path="/admin/campaign" component={Campaign} />
                <Route path="/admin/create-promotion" component={CreatePromotion} />
                <Route path="/admin/master-data2" component={MasterData2} />
                <Route path="/admin/run-promotions" component={RunPromotions}/>
                <Route path="/admin/view-promotion-list" component={PromotionMaster}/>
                <Route path="/admin/brand-view-promotion/:id" component={BrandViewPromotion}/>
                <Route path="/admin/merchant-upload" component={MerchantUpload}/>
                {/* <Route path="/admin/merchant-master" component={MerchantMaster}/> */}
                <Route path="/admin/admin-view-promotion/:id" component={AdminViewPromotion}/>
                {/*<Route path="/admin/scheme-master" component={SchemeMaster}/>*/}
                {/*<Route path="/admin/scheme-viewer/:id" component={SchemeViewer}/>*/}
                <Route path="/admin/merchant-viewer/:id" component={MerchantViewer}/>
                <Route path="/admin/edit-promotion/:id" component={EditPromotion}/>
                <Route path="/admin/schemes-list" component={SchemesList}/>
                <Route path="/admin/create-schemes" component={CreateSchemes}/>
                <Route path="/admin/create-schemes-multiple" component={CreateSchemesMultiple}/>
                <Route path="/admin/merchant-promotions" component={MerchantPromotionMaster}/>
                <Route path="/admin/merchant-view-promotion/:id" component={MerchantViewPromotion}/>
                <Route path="/admin/admin-upload-products" component={AdminUploadProducts}/>
                <Route path="/admin/data-exporter" component={DataExporter}/>
                <Route path="/admin/merchant-mapper" component={NewUnmappedView}/>
                <Route path="/admin/merchant-product-mapper" component={BrandMerchantProductMapper}/>
                <Route path="/admin/merchant-brand-product-mapper" component={MerchantBrandProductMapper}/>
                <Route path="/admin/admin-create-schemes" component={AdminCreateSchemes}/>
                <Route path="/admin/admin-schemes-list" component={AdminSchemesList}/>
                <Route path="/admin/admin-new-schemes-list" component={AdminNewSchemesList}/>
                <Route path="/admin/admin-promotion-master" component={AdminPromotionMasterBackend}/>
                <Route path="/admin/admin-promotion-master-backend" component={AdminPromotionMaster}/>
                <Route path="/admin/admin-edit-promotion/:id" component={AdminEditPromotion}/>
                <Route path="/admin/admin-create-promotion" component={AdminCreatePromotion}/>
                <Route path="/admin/be-dashboard" component={NewDashboard}/>
                <Route path="/admin/new-merchant-master" component={NewMerchantMaster}/>
                <Route path="/admin/new-create-promotion" component={NewCreatePromotion}/>
                <Route path="/admin/new-edit-promotion/:id" component={NewEditPromotion}/>
                <Route path="/admin/new-view-promotion/:id" component={NewViewPromotion}/>
                <Route path="/admin/admin-new-create-schemes" component={AdminNewCreateSchemes}/>
                <Route path="/admin/admin-new-create-schemes-bank" component={AdminNewCreateSchemesBankEMI}/>
                <Route path="/admin/admin-new-create-schemes-view/:id" component={AdminNewCreateSchemesView}/>
                <Route path="/admin/admin-new-create-schemes-bank-view/:id" component={AdminNewCreateSchemesViewBankEMI}/>
                <Route path="/admin/admin-new-create-schemes-edit/:id" component={AdminNewCreateSchemesEdit}/>
                <Route path="/admin/new-schemes-master" component={NewSchemesMaster}/>
                <Route path="/admin/new-data-exporter" component={NewDataExporter}/>
                <Route path="/admin/new-data-exporter2" component={NewDataExporter2}/>
                <Route path="/admin/automation-button" component={AutomationButton}/>
                <Route path="/admin/automation-button-old" component={AutomationButtonOld}/>
                <Route path="/admin/automation-button-latest" component={AutomationButtonLatest}/>
                <Route path="/admin/merchant-master" component={MerchantBrandIntegration}/>
                {/* <Route path="/admin/merchant-master1" component={LatestMerchantMaster1}/> */}
                <Route path="/admin/new-brand-viewer/:id" component={NewBrandViewer} />
                <Route path="/admin/new-brand-viewer-new/:id" component={NewBrandViewerNew} />
                <Route path="/admin/email-users" component={EmailUsers} />
                <Route path="/admin/manage-communication" component={ManageCommunication} />
                <Route path="/admin/scheme-enablement-report" component={BrandEMISchemeEnablement} />
                {/* <Route path="/admin/brand-email-config" component={BrandEmailConfig} /> */}
                {/* <Route path="/admin/brand-emi-sales-report-new" component={BrandEMISalesReportNew} /> */}
                <Route path="/admin/brand-emi-transaction-report" component={BrandEMITransactionReportNew} />
                <Route path="/admin/brand-emi-api-log-report" component={APILogReport} />
                <Route path="/admin/admin-create-promotion1" component={AdminCreatePromotion1}/>
                <Route path="/admin/admin-view-promotion1/:id" component={AdminViewPromotion1}/>
                <Route path="/admin/admin-edit-promotion1/:id" component={AdminEditPromotion1}/>
                {/* <Route path="/admin/admin-new-schemes-list2" component={AdminNewSchemesList2}/> */}
                <Route path="/admin/brand-emi-transaction-report-new" component={BrandEMITransactionReport} />
                <Route path="/admin/brand-emi-mis" component={BrandEMIMIS} />
                <Route path="/admin/promotion-mapping" component={PromotionMapping} />
                                <Route path="/admin/totalemi-trans-details" component={TotalEmiTransDetails} />
                                <Route path="/admin/acqurier-dashboard" component={AcqurierDashboard} />
                                <Route path="/admin/merchant-dashboard" component={MerchantDashboard} />
                                <Route path="/admin/DashboardDetails" component={DashboardDetails}  />
                                <Route path="/admin/invoice-dashboard" component={InvoiceDashboard} />
                                <Route path="/admin/invoice-transaction" component={Transaction} />
                                <Route path="/admin/invoices" component={Invoice} />
                                <Route path="/admin/invoice" component={AdminInvoice} />
                                <Route path="/admin/invoice" component={AdminInvoice} />
                                <Route path="/admin/invoice-process" component={InvoiceProcess} />
                                <Route path="/admin/pricing-rules" component={MasterDataV2} />
                                <Route path="/admin/additional-data" component={AdditionalData}/>
                                <Route path="/admin/barcode" component={BarCode}/>
                                <Route path="/admin/transaction-report-history-test" component={FlatFilesTest}/>
                                <Route path="/admin/stellr-report" component={StellrReport}/>
                                <Route path="/admin/genie-wallet-balance-report" component={GenieWalletBalance}/>
                                 <Route path="/admin/SapphireFoodDownloadReport" component={SapphireFoodDownloadReport}  />
                                 <Route path="/admin/i-download" component={IdownloadReport}  />
                                 <Route path="/admin/genie-margin-mtd-report" component={GenieMarginMtdReport} />
                                 <Route path="/admin/bin-manager-report" component={BinManagerReport} />
                                 <Route path="/admin/flexi-pay-transaction-report" component={FlexiPayTransactionReport} />
                                 <Route path="/admin/tableau-reports" component={TableauReports} />
                                 <Route path="/admin/tableau-workbook/:id" component = {TableauWorkbook}/>
                                 <Route path="/admin/tableau-worksheet/:id" component = {TableauWorksheet}/>
                                 <Route path="/admin/tableau-report/:id" component = {TableauReport}/>
                                 <Route path="/admin/tableau-report-test/:id" component = {TableauReportTest}/>
                                 <Route path="/admin/unsupported-terminal-report" component = {UnsupportedTerminalsReports}/>
                                 <Route path="/admin/bin-manager-summary-report" component = {BinManagerSummaryReport}/>
                                 <Route path = "/admin/utid-wise-summary-report" component = {RelianceUtidSummaryReport}/>
                                 <Route path = "/admin/reliance-utid-wise-billing-summary-report" component = {RelianceUtidWiseBillingSummaryReport}/>
                                 <Route path="/admin/product-error-report" component = {ProductErrorReport}/>
                                 <Route path="/admin/test-multi-download" component = {ProductErrorReportTest}/>
                                 <Route path="/admin/user-access-permission" component = {UserAccessPermission}/>
                                 <Route path="/admin/report-download-queue" component = {DownloadQueue}/>
                                 <Route path="/admin/monthwise-summary" component = {MonthWiseSummary}/>
                                 <Route path="/admin/active-utids" component = {ActiveUtid}/>
                                 <Route path="/admin/adani-gas-station-daily-report" component={AdaniGasStationDailyReport} />
                                 <Route path="/admin/upi-vpa-handler-report" component={UpiVpaHandlerReport} />
                                 <Route path="/admin/live-txn-dump-report" component={LiveTransactionDumpReport} />
                                 <Route path="/admin/reliance-grab-upi-transaction-report" component={RelianceGrabUpiPayTransactionReport} />
{/*                                   <Route path="/admin/daily-transaction-report-test" component={EodTransactionReport1} /> */}
{/*                                 <Route path="/admin/daily-transaction-report-test2" component={EodTransactionReport2} /> */}
                                 <Route path="/admin/btid-gap-report" component={BtidGapReport}/>
                                 <Route path="/admin/enigmatic-smile-txn-report" component={EnigmaticSmileReport}/>
                                 <Route path="/admin/e-rupee-txn-report" component={ErupeeTransactionReport}/>
                                 <Route path="/admin/tableau-embed1" component={TableauEmbed1}/>
                                 <Route path="/admin/tableau-embed2/:id" component={TableauEmbed2}/>
                                 <Route path="/admin/lounge-views/:id" component={LoungeView1} />
                                 <Route path="/admin/dms-views/:id" component={DmsView} />
                                 <Route path="/admin/lounge-partner-dashboard/:id" component={LoungePartnerReport} />
                                 <Route path="/admin/donation-dashboard/:id" component={DonationReport} />
                                 <Route path="/admin/lounge-admin/:id" component={LoungeReportAPI} />
                                 <Route path="/admin/lounge-admin-qa/:id" component={LoungeReportAPIQA} />
                                 <Route path="/admin/donation-dashboard-test/:id" component={DonationReportForTest} />
                                 <Route path="/admin/heat-map/" component={HeatMap} />
                                 <Route path="/admin/genie-acquisition-report/" component={GenieAcquisitionReport} />
                                 <Route path="/admin/admin-clone-promotion/:id" component={AdminClonePromotion}/>
                                 <Route path="/admin/ubc-txn-report/" component={UBCTransactionReport}/>
                                 <Route path="/admin/bvp-dashboard/" component={BvpDashboard} />
                                 <Route path="/admin/create-new-campaign/" component={AddCampaign} />
                                 <Route path="/admin/edit-campaign/:id" component={EditCampaign} />
                                 <Route path="/admin/view-campaign/:id" component={ViewCampaign} />
                                 <Route path="/admin/hdfc-upi-txn-report/" component={HDFCUPITransactionReport}/>
                                 <Route path="/admin/grd-dump-report/" component={GRDDumpReport} />
                                 <Route path="/admin/genie-roi/" component={GenieRoi} />
                                 <Route path="/admin/view-kyc-document/:id" component={LinkPKYCDocument}/>
                                 <Route path="/admin/view-history/:id" component={LinkMerchantMovementHistory}/>
                                 <Route path="/admin/beat-plan-report/" component={BeatPlanReport}/>
                                 <Route path="/admin/view-beat-plan-details/" component={BeatPlanDetailReport}/>
                                 <Route path="/admin/link-pkyc-report/" component={LinkPKYCReport}/>
                                 <Route path="/admin/crisp-chargeback-report/" component={ChargebackReport} />
                                 <Route path="/admin/crisp-refund-report/" component={RefundReport} />
                                 <Route path="/admin/crisp-business-volume-report/" component={BussinessVolumeReport} />
                                 <Route path="/admin/police-complaint-report/" component={ComplaintReport} />
                                 <Route path="/admin/create-new-complaint/" component={AddComplaint} />
                                 <Route path="/admin/edit-complaint/:id" component={EditComplaint} />
                                 <Route path="/admin/finance-report/" component={CrispFinanceReport} />
                                 <Route path="/admin/failed-upi-txn-to-eft/" component={FailedUPITransactionToEFTReport} />
{/*                                  <Route path="/admin/view-beat-plan/" component={MapWithRoute} /> */}
                                 <Route path="/admin" component={Page404} />

                            </Switch>
                            {!isMobile && <Footer />}
                        </div>
                    </div>
                </div>
                {isMobile && this.props.menuname==="totalemi" && <TotalEMINavbar />}

                {isMobile && this.props.menuname==="unipaynext" && <UnipayNextNavbar UnipayParentCallback={this.UnipayCallback}/>}
            </>
        );
    }
}


const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
const mapStateToProps = (state) =>{
    console.log("admin nam eis:"+state.name)
    return { menuname: state.name}
}

export default connect(mapStateToProps,mapDispatchToProps)(Admin);